<template>
	<div class="carousel-box" :style="imgHeight > 0 ? 'margin-top: 120px;' : ''">
		<div v-if="imgHeight > 0">
			<VCarousel :imgList="carouselList" :img-height="200" />
		</div>
		<div class="chart-box">
			<v-home-page-echarts :charts-data="chartsList"></v-home-page-echarts>
		</div>
		<div class="table-box">
			<div class="c-flex-space-between c-flex-align-center">
				<div class="c-flex">
					<template v-for="(item, index) in symbolList">
						<div v-if="item.baseSymbol !== $t('trade_ctc.header.self')"
							:class="[{ 'item-s': coinFilter.listIndex === index }, 'item']"
							@click="coinListChange(index)">
							{{ usdt2Usd(item.baseSymbol) }}
						</div>
					</template>
				</div>
				<el-input class="input-box1" :placeholder="$t('home.table.header.search')" suffix-icon="el-icon-search"
					v-model="coinFilter.keyword" @change="getFilterCoinTable" />
			</div>
			<!-- :height="tableHeight" -->
			<el-table v-if="symbolList.length > 0" :data="coinTable" style="width: 100%; margin-top: 40px"
				@row-click="jumpToMarket">
				<el-table-column prop="date" :label="$t('home.table.row.rwatype')" align="center">
					<template slot-scope="scope">
						<div class="c-flex-left">
							<template>
								<img v-if="!scope.row.collect" @click.stop="changeSymbol(scope.row, 2)" class="star-img"
									src="@/assets/img/images/icon/star.png" alt="star" />
								<img v-else class="star-img" src="@/assets/img/images/icon/star-blue.png"
									@click.stop="changeSymbol(scope.row, 1)" alt="star" />
							</template>
							<template>
								<img v-if="scope.row.icon" class="zuanshi-img" :src="scope.row.icon" alt="star" />
							</template>
							<p>
								{{ scope.row.s.split("/")[0] }}
								<!-- <label style="color: #a0aac1">/{{ scope.row.s.split("/")[1] }}</label> -->
							</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="date" :label="$t('home.table.row.price')" align="center">
					<template slot-scope="scope">
						<div class="c-flex-center">
							<p>{{ getFloorNum(scope.row.c, getSymbolPrecision(scope.row.s, 'price')) }}</p>
							<img v-if="scope.row.p >= 0" class="arrow-img" src="@/assets/img/images/icon/arrow-top.png"
								alt="star" />
							<img v-else class="arrow-img" src="@/assets/img/images/icon/arrow-down.png" alt="star" />
						</div>
					</template>
				</el-table-column>
				<el-table-column :label="$t('home.table.row.high')" align="center">
					<template slot-scope="scope">
						{{ getFloorNum(scope.row.h, getSymbolPrecision(scope.row.s, 'price')) }}
					</template>
				</el-table-column>
				<el-table-column :label="$t('home.table.row.low')" align="center">
					<template slot-scope="scope">
						{{ getFloorNum(scope.row.l, getSymbolPrecision(scope.row.s, 'price')) }}
					</template>
				</el-table-column>
				<el-table-column prop="p" :label="$t('home.table.row.rang')" align="center" sortable
					:sort-method="getSort_p">
					<template slot-scope="scope">
						<p :style="{ color: scope.row.p >= 0 ? '#52C18E' : '#F04545' }">
							{{ scope.row.p >= 0 ? '+' : '' }}{{ getFloorNumAndComplemented(scope.row.p * 100, 2) }}%
						</p>
					</template>
				</el-table-column>
				<el-table-column :label="$t('home.table.row.volume')" align="center" sortable
					:sort-method="getSort_v">
					<template slot-scope="scope">
						{{ getFloorNum(scope.row.v, getSymbolPrecision(scope.row.s, 'coin')) }}
					</template>
				</el-table-column>
				<el-table-column :label="$t('home.table.row.amount')" align="center" sortable
					:sort-method="getSort_to">
					<template slot-scope="scope">
						{{ getFloorNum(scope.row.to, getSymbolPrecision(scope.row.s, 'price')) }}
					</template>
				</el-table-column>
			</el-table>
			<div class="more-box" @click="tableShowMore">
				{{ $t("home.table.more") }}
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from "vuex";
	import VCarousel from "@/components/Carousel/VCarousel";
	import VHomePageEcharts from "@/components/HomePageEcharts/VHomePageEcharts";
	import precisionMixin from '@/mixins/precisionMixin';
	export default {
		mixins: [precisionMixin],
		components: {
			VCarousel,
			VHomePageEcharts,
		},
		data() {
			return {
				socket: null,
				klineUrl: "",
				number: 0,
				registerNum: 0,
				annList: [],
				chartsList: [],
				filterData: {
					keyword: "",
					type: "self",
				},
				qr_ios: false,
				qr_android: false,
				register_account: "",
				coinFilter: {
					keyword: "",
					listIndex: 1,
				},
				showMore: false,
				tableHeight: "auto",
				originalSymbol: [], //一次调用接口获取的原始交易对信息
				allMarketData: null, //所有交易对行情
				coinTable: [], //当前显示的交易对
				symbolList: [], //所有交易对
				pingTime: 0,

				imgHeight: 0,
				carouselList: [],
				selectedSymbol: {},
			};
		},
		computed: {
			...mapState({
				user: "user",
				errorCode: "errorCode",
			}),
		},

		created() {
			this.getCarouselList();
			this.getMemberNumber();
			this.getWebsocket();
			this.getNotifyTexts();
			this.webSocketWatch();
		},
		mounted() {
			if (!this.user.username || !window.localStorage.getItem("jwt-token")) {
				this.coinFilter.listIndex = 1;
			}
			if (document.getElementById("launcher")) {
				document.getElementById("launcher").style.display = "block";
			}
		},
		beforeDestroy() {
			if (document.getElementById("launcher")) {
				document.getElementById("launcher").style.display = "none";
			}
		},
		destroyed() {
			this.socket.close();
		},
		methods: {
			usdt2Usd(token){
				if(token) {
					token = token.replace("T", "");
					return token;
				}
			},
			
			//websocket心跳间隔计时器
			webSocketWatch() {
				let that = this;
				this.socketTimer = setInterval(function() {
					that.pingTime = that.pingTime + 5;
				}, 5000);
			},

			// 设置Echarts数据
			setEchartsData(data) {
				if(!data) {
					return;
				}
				
				let obj = {
					symbol: "",
					coinType: "",
					unit: "",
					up: false,
					range: "",
					price: "",
					charts: [],
				};

				let symbolArr = data.s.split("/");
				obj.symbol = symbolArr[0] + "-" + symbolArr[1];
				obj.coinType = symbolArr[0];
				obj.unit = symbolArr[1];

				this.chartsList = [];
				this.chartsList.push(obj);

				this.getAllEcharts();
				
				this.$set(this.allMarketData[data.s], "collect", true); //已选择			
				this.selectedSymbol = data;
				window.localStorage.setItem(
					"$selectedSymbol",
					JSON.stringify(this.selectedSymbol),
				);
			},

			//获取首页Echarts数据
			getHomePageData() {
				let that = this;
				this.$axios.post("/HomePage/all", {}).then((res) => {
					if (res.data.code === this.errorCode.ok) {
						let hotList = res.data.data.hotSymbolTickers;
						for (let i = 0; i < hotList.length && i < 5; i++) {
							let obj = {
								symbol: "",
								coinType: "",
								unit: "",
								up: false,
								range: "",
								price: "",
								charts: [],
							};
							let symbolArr = hotList[i].s.split("/");
							obj.symbol = symbolArr[0] + "-" + symbolArr[1];
							obj.coinType = symbolArr[0];
							obj.unit = symbolArr[1];
							that.chartsList.push(obj);
						}
						this.getAllEcharts();
					}
					//客服组件放在这里再加载
					if (!document.getElementById("launcher")) {
						//判断是否已经加载了客服，没有则加载
						let script = document.createElement("script");
						script.id = "ze-snippet";
						script.type = "text/javascript";
						script.src =
							"https://static.zdassets.com/ekr/snippet.js?key=03808066-149e-49a7-91c5-c40cbcdcf7df";
						script.setAttribute("defer", "true");
						document.getElementsByTagName("head")[0].appendChild(script);
					}
				});
			},
			//获取已加入人数
			getMemberNumber() {
				this.$axios.post("/Copartner/QueryMemberCount", {}).then((res) => {
					if (res.data.code === this.errorCode.ok) {
						this.number = res.data.data.sum;
						this.registerNum = res.data.data.sumAll ? res.data.data.sumAll : 0;
					}
				});
			},
			//跳转到行情页面
			jumpToMarket(row, event, column) {
				this.$router.push({
					path: "/ctc",
					query: {
						symbol: row.s
					}
				});
			},
			//系统通知
			getNotifyTexts() {
				this.$axios.post("/HomePage/notifyTexts", {}).then((res) => {
					if (res.data.code === this.errorCode.ok) {
						this.annList = res.data.data;
					}
				});
			},
			//交易对列表改变
			coinListChange(index) {
				this.coinFilter.listIndex = index;
				if (this.symbolList.length > 0 && index < this.symbolList.length) {
					//获取所有交易对的接口有可能还未返回值
					this.coinTable = this.symbolList[index].coinSymbols;
				}
				if (!this.showMore && this.coinTable.length < 10) {
					if (this.coinTable.length === 0) {
						this.tableHeight = "162px";
					} else {
						this.tableHeight = 59 + 100 * this.coinTable.length + "px";
					}
				} else if (!this.showMore) {
					this.tableHeight = "780px";
				} else {
					this.tableHeight = "auto";
					document.getElementsByClassName(
						"el-table__body-wrapper",
					)[0].style.height = "auto";
				}
			},
			tableShowMore() {
				this.$router.push({
					path: "/ctc"
				});
				// this.showMore = true;
				// this.tableHeight = "auto";
				// document.getElementsByClassName(
				//   "el-table__body-wrapper",
				// )[0].style.height = "auto";
			},
			//搜索交易对列表
			getFilterCoinTable() {
				if (this.symbolList[this.coinFilter.listIndex]) {
					if (this.coinFilter.keyword) {
						this.coinTable = this.symbolList[
							this.coinFilter.listIndex
						].coinSymbols.filter((item) => {
							return (
								item.s
								.split("/")[0]
								.indexOf(this.coinFilter.keyword.toUpperCase()) >= 0
							);
						});
					} else {
						this.coinTable =
							this.symbolList[this.coinFilter.listIndex].coinSymbols;
					}
				}
			},
			getWebsocket() {
				let that = this;
				let Socket = new WebSocket(
					this.$axios.defaults.baseWS +
					"/ws/client/h5/" +
					(this.user.userId ? this.user.userId : 99000000),
				);
				this.socket = Socket;
				let tickerStr = "market.ticker";
				Socket.onopen = function() {
					console.log("WebSocket开启");
					Socket.send(JSON.stringify({
						sub: tickerStr
					})); //订阅ticker(交易对行情)
				};
				Socket.onmessage = function(res) {
					let retData = JSON.parse(res.data);
					if (retData.ping) {
						//心跳返回 记录心跳时间并且返回pong
						that.pingTime = 0;
						Socket.send(JSON.stringify({
							pong: retData.ping
						}));
					} else if (retData.sub === tickerStr) {
						//ticker数据
						if (!that.allMarketData) {
							that.allMarketData = retData.data;

							//首次获取则获取交易对列表
							that.getSymbolList();
							//that.getHomePageData(); //获取echarts信息
						} else {
							for (let key in retData.data) {
								//向allMarketData中更新或者添加交易对信息,理论上所有交易对都有，只需更新
								if (that.allMarketData.hasOwnProperty(key)) {
									that.allMarketData[key] = retData.data[key];
								} else {
									that.$set(that.allMarketData, key, retData.data[key]);
								}
							}
							that.getAllCoinMarket(that.originalSymbol); //重新整理拼接用于展示的交易对
							that.coinListChange(that.coinFilter.listIndex); //更新显示表格
							that.getFilterCoinTable(); //过滤交易对
							// that.getAllEcharts();
						}
					}
				};
				Socket.onclose = function() {
					console.log("WebSocket关闭");
				};
			},

			// 切换币种K线
			changeSymbol(row, status) {
				this.setEchartsData(row);
				this.coinListChange(this.coinFilter.listIndex);
				this.symbolList.forEach((item, index) => {
					item.coinSymbols.forEach((item1, index1) => {
						item1.collect = false;
					});
				});
				row.collect = true;
			},

			// 加入自选
			updateSymbol(row, status) {
				this.$axios
					.post("/user/updateSymbol", {
						symbol: row.s,
						status: status
					})
					.then((res) => {
						if (res.data.code === this.errorCode.ok) {
							this.coinListChange(this.coinFilter.listIndex);
							this.$store.commit("updateSymbol", {
								symbol: row.s,
								status: status,
							});
							row.collect = !row.collect;
							//更新自选列表
							if (status === 1) {
								this.symbolList[0].coinSymbols.push(row); //加入自选列表
							} else {
								this.symbolList[0].coinSymbols.forEach((value, index) => {
									if (value.s === row.s) {
										this.symbolList[0].coinSymbols.splice(index, 1); //从自选列表删除
									}
								});
							}
						} else {
							this.$message({
								type: "error",
								message: res.data.msg,
							});
						}
					});
			},
			//整理拼接用于展示交易对  symbolList:接口获取的原始交易对
			getAllCoinMarket(symbolList) {
				let that = this;
				this.symbolList = this.deepCopy(symbolList); //深拷贝,为了保留从接口获取的原始交易对数组
				//数组头部插入空自选列表
				this.symbolList.unshift({
					baseSymbol: that.$t("trade_ctc.header.self"),
					coinSymbols: [],
				});
				for (let i = 1; i < that.symbolList.length; i++) {
					let baseSymbol = that.symbolList[i].baseSymbol;
					let coinList = that.symbolList[i].coinSymbols;
					let newCoinList = [];
					for (let j = 0; j < coinList.length; j++) {
						//创建新的交易对行情数组
						let symbol = coinList[j].coinSymbol + "/" + baseSymbol;
						if (that.allMarketData.hasOwnProperty(symbol)) {
							that.user.symbol.forEach((value) => {
								if (value === symbol) {
									that.$set(that.allMarketData[symbol], "collect", false); //已收藏
									that.symbolList[0].coinSymbols.push(that.allMarketData[symbol]); //加入自选列表
								}
							});
							if (!that.allMarketData[symbol].hasOwnProperty("collect")) {
								that.$set(that.allMarketData[symbol], "collect", false); //未收藏
							}
							that.$set(that.allMarketData[symbol], "icon", coinList[j].icon); //加入图标icon地址
							newCoinList.push(that.allMarketData[symbol]);
						}
					}
					that.symbolList[i].coinSymbols = newCoinList;
				}
				
				// 设置Echarts数据，先从本地缓存获取是否已选择
				let $selectedSymbol = window.localStorage.getItem('$selectedSymbol');
				that.selectedSymbol = $selectedSymbol ? JSON.parse($selectedSymbol) : that.allMarketData["RWA/USDT"];
				that.setEchartsData(that.selectedSymbol);
			},
			//获取所有交易对
			getSymbolList() {
				this.$axios.post("/exchangeCoin/getAll", {}).then((res) => {
					if (res.data.code === this.errorCode.ok) {
						this.originalSymbol = res.data.data.symbolArray;
						this.getAllCoinMarket(this.originalSymbol);
						this.coinListChange(this.coinFilter.listIndex);
					}
				});
			},
			//获取所全部echarts里ticker数据
			getAllEcharts() {
				this.chartsList.forEach((value) => {
					let symbol = value.symbol.replace("-", "/");
					value.range =
						this.getFloorNumAndComplemented(
							this.allMarketData[symbol].p * 100,
							2,
						) + "%";
					value.price = this.allMarketData[symbol].c;
					value.up = this.allMarketData[symbol].p >= 0;
				});
			},
			jumpWithAccount() {
				this.$router.push({
					path: "/register",
					query: {
						account: this.register_account
					},
				});
			},
			// 获取Banner列表
			getCarouselList() {
				this.$axios
					.post("/cms/getList", {
						page: 1,
						rows: 10,
						cateCode: "banner",
					})
					.then((res) => {
						this.carouselList = res.data.data.rows || [];
						this.imgHeight =
							this.carouselList && this.carouselList.length > 0 ? 200 : 0;
					});
			},
		},
		watch: {
			pingTime() {
				if (this.pingTime >= 30) {
					//console.log('websocket心跳超时，关闭重连……');
					this.socket.close();
					this.getWebsocket();
					this.pingTime = 0;
				}
			},
			"user.username": function() {
				this.symbolList[0].coinSymbols = [];
				this.coinFilter.listIndex = 1;
				this.coinListChange(this.coinFilter.listIndex);
			},
		},
	};
</script>

<style lang="less" scoped>
	.carousel-box {
		margin: 0 auto;
		position: relative;
		width: calc(100% - 520px);

		.chart-box {
			margin-top: 120px;
			padding: 0 20px;

			#lineChartId {
				width: 100%;
				height: 100px;
				margin-top: 20px;
			}

			.title2 {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
			}

			.title3 {
				font-family: PingFang SC, PingFang SC;
				font-weight: 800;
				font-size: 16px;
				color: #5eba89;
			}

			.title1 {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 23px;
				color: #333333;
			}
		}

		.table-box {
			margin-top: 40px;

			.input-box1 {
				height: 44px;
				width: 238px;

				/deep/.el-input__inner {
					height: 44px;
					background: #ffffff;
					border-radius: 4px 4px 4px 4px;
					border: 1px solid #e2e3e3;
				}
			}

			.more-box {
				margin: 0 auto;
				margin-top: 40px;
				cursor: pointer;
				width: 315px;
				height: 57px;
				line-height: 57px;
				text-align: center;
				border-radius: 4px 4px 4px 4px;
				border: 1px solid #4063ff;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #4063ff;
			}

			.star-img {
				width: 22px;
				height: 22px;
				margin-right: 12px;
			}

			.zuanshi-img {
				width: 28px;
				height: 28px;
				margin-right: 8px;
			}

			.arrow-img {
				width: 7px;
				height: 12px;
				margin-left: 8px;
			}

			/deep/ .el-table .descending .sort-caret.descending {
				border-top-color: #4063ff;
			}

			/deep/ .el-table .ascending .sort-caret.ascending {
				border-bottom-color: #4063ff;
			}

			.item {
				cursor: pointer;
				text-align: center;
				width: 180px;
				height: 44px;
				line-height: 44px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 20px;
				color: #333333;
			}

			.item-s {
				background: #4063ff;
				border-radius: 2px 2px 2px 2px;
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 20px;
				color: #ffffff;
			}
		}

		/deep/.control-slider {
			width: 44px !important;
			height: 8px !important;
			background: #dcdcdc !important;
			border-radius: 4px 4px 4px 4px !important;
		}

		/deep/.show-slider {
			width: 44px !important;
			height: 8px !important;
			background: #4063ff !important;
			border-radius: 4px 4px 4px 4px !important;
		}
	}
</style>